import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type ContentLanguage } from '@@lib/i18n/constants';

import { type RtElementListSearchParams } from './rtElementListSearchParams';

export const rtElementListQuery = (
    search: RtElementListSearchParams,
    contentLocale: ContentLanguage,
) =>
    client.rtelements.rtElements.getAll.queryOptions({
        query: { q: search.q, tenantIds: search.tenantIds },
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });
